import http from './http';

export const searchUsers = async (q) => {
  const { data } = await http.get('/api/users/search', { params: { q } });
  return data.users || [];
};

export async function getUserBilling(userId) {
  const { data } = await http.get(`/api/users/${userId}/billing`);
  return data.billing || { name: '', inn: '', kpp: '', address: '' };
}
